const CaretDoubleUp = ({
  width = '25',
  height = '24',
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_9912_20686"
        maskUnits="userSpaceOnUse"
        x="-1"
        y="0"
        width={width}
        height={height}
      >
        <path
          d="M23.9951 0.984863H-0.00488281V24.9849H23.9951V0.984863Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_9912_20686)">
        <path
          d="M10.9218 3.40635C11.8952 2.84437 13.0944 2.84436 14.0678 3.40634L20.0035 6.83334C20.9769 7.39532 21.5766 8.4339 21.5766 9.55786V16.4119C21.5766 17.5359 20.9769 18.5744 20.0035 19.1364L14.0678 22.5634C13.0944 23.1254 11.8952 23.1254 10.9218 22.5634L4.98609 19.1364C4.01271 18.5744 3.41309 17.5359 3.41309 16.4119V9.55786C3.41309 8.4339 4.01271 7.39532 4.98609 6.83334L10.9218 3.40635Z"
          fill="url(#paint0_linear_9912_20686)"
        />
        <path
          d="M15.9951 12.3182L12.4951 8.98486L8.99512 12.3182"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.9951 16.3182L12.4951 12.9849L8.99512 16.3182"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_9912_20686"
          x1="3.46133"
          y1="2.98486"
          x2="40.3422"
          y2="10.8591"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A256BC" />
          <stop offset="1" stopColor="#298ee6" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default CaretDoubleUp;
